import {createApi} from '@reduxjs/toolkit/query/react';

import httpBaseQuery from 'shared/api/rtk-query/httpBaseQuery';
import {ApiUrls} from 'shared/config/model/urls';

import ITag from 'shared/model/ITags';

import {normalizeTag} from '../lib/normalizeTags';
import {invalidateTaggedEntities} from '../model/tagsCacheEvents';

export const tagsAPI = createApi({
    reducerPath: 'tagsAPI',
    baseQuery: httpBaseQuery(),
    tagTypes: ['Tags'],
    refetchOnMountOrArgChange: 60,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    endpoints: (build) => ({
        getTags: build.query<ITag[], void>({
            query: () => ({
                path: ApiUrls.TAGS,
                method: 'GET',
            }),
            providesTags: ['Tags'],
        }),
        addTag: build.mutation<ITag, string>({
            query: (label) => ({
                path: ApiUrls.TAGS,
                method: 'POST',
                data: {label: normalizeTag(label)},
                silent: true,
            }),
            invalidatesTags: ['Tags'],
        }),
        deleteTag: build.mutation<void, string>({
            query: (id) => ({
                path: ApiUrls.TAG(id),
                method: 'DELETE',
            }),
            async onQueryStarted(id, {dispatch, queryFulfilled}) {
                await queryFulfilled;
                invalidateTaggedEntities(dispatch);
            },
            invalidatesTags: ['Tags'],
        }),
    }),
});
